import { CronExpressionParser } from "cron-parser";

/**
 * Validate and parse a 5-field cron expression.
 * Returns the parsed interval on success, throws on invalid input.
 */
export function parseCronSchedule(expr: string) {
  try {
    return CronExpressionParser.parse(expr);
  } catch {
    throw new Error(`Invalid cron expression: ${expr}`);
  }
}
